module.exports = __webpack_public_path__ + "img/r8.56d6fe13.svg";